import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  TextInput,
} from '@met/react-components';
import React, { useEffect, useRef, useState } from 'react';

const AddProjectModal = ({ hidden, toggle, onSaveClick }) => {
  const [name, setName] = useState('');
  const projectRef = useRef(null);

  useEffect(() => {
    if (!hidden) projectRef.current.focus();
  }, [hidden, projectRef]);

  const handleSaveClick = () => {
    onSaveClick(name)
      .then(() => setName(''))
      .then(() => toggle());
  };

  const handleKeyPress = event => {
    if (event.key === 'Enter') {
      handleSaveClick();
    }
  };

  return (
    <Modal centered hidden={hidden} toggle={toggle}>
      <ModalContent>
        <ModalHeader toggle={toggle}>Add Project</ModalHeader>
        <ModalBody>
          <p>
            A project contains a grouping of languages and translations. Create
            a new Milwaukee Intl project per application you are developing.
          </p>
          <TextInput
            inputRef={projectRef}
            placeholder='Project Name'
            value={name}
            onChange={e => setName(e.target.value)}
            onKeyPress={handleKeyPress}
          />
        </ModalBody>
        <ModalFooter>
          <Button onClick={toggle}>Close</Button>
          <Button primary onClick={handleSaveClick}>
            Save Changes
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddProjectModal;
